import api from "./api";

// Achado da revisão de sessão (06/09/2026): antes, QUALQUER erro aqui —
// 401 genuíno de refresh token expirado/revogado, mas também timeout, wifi
// caindo, backend momentaneamente fora do ar — caía no mesmo catch e
// retornava null. Todo caller (api.js, App.js, useSessionTimer.js) tratava
// null como "sessão morta" e limpava o localStorage inteiro, forçando
// login de novo. Resultado: uma queda de sinal de 2s numa academia bastava
// pra derrubar uma sessão 100% válida.
//
// Agora a função diferencia os dois casos:
//   - retorna null  → o BACKEND respondeu e rejeitou o refresh token
//     (401/403 — expirado ou revogado de verdade). É logout de verdade.
//   - lança (throw) → não teve resposta do backend (rede caiu, timeout,
//     5xx, CORS). Não é motivo pra derrubar a sessão — quem chamou deve
//     manter o usuário logado e tentar de novo depois.
export async function refreshToken() {
  const storedRefresh = localStorage.getItem("refreshToken");
  if (!storedRefresh) {
    console.warn("[refreshToken] sem refreshToken no localStorage");
    return null;
  }

  let res;
  try {
    res = await api.post("/login/refresh", { refresh_token: storedRefresh });
  } catch (err) {
    const status = err?.response?.status;
    if (status === 401 || status === 403) {
      console.error("[refreshToken] refresh token rejeitado pelo backend:", status);
      return null;
    }
    console.warn("[refreshToken] falha de rede/servidor ao renovar — mantendo sessão:", err?.message);
    throw err;
  }

  const token = res.data.access_token;
  localStorage.setItem("token", token);
  if (res.data.refresh_token) {
    localStorage.setItem("refreshToken", res.data.refresh_token);
  }

  const payload = JSON.parse(atob(token.split(".")[1]));
  localStorage.setItem("expiresAt", payload.exp * 1000);

  return token;
}

export function getAccessToken() {
  return localStorage.getItem("token") || "";
}

export function getTokenExpiration() {
  const exp = localStorage.getItem("expiresAt");
  return exp ? Number(exp) : 0;
}

export function isTokenExpired() {
  const exp = getTokenExpiration();
  if (!exp) return true;
  return Date.now() > exp;
}
